import { useLocalZonePreference } from '@/hooks/useLocalZonePreference';
import { MetricConfig } from '@/types/evals';
import { formatTimestamp } from '@/utils/timeFormatter';

import { InfoCard } from '../../_components/InfoCard';
import { InfoCardRow } from '../../_components/InfoCardRow';

type Props = {
  config: MetricConfig;
};

export function MetricFooterRow( { config }: Props ) {
  const [ useLocalZone ] = useLocalZonePreference();

  return (
    <InfoCardRow data-testid="metric-footer-row">
      <InfoCard label="Version Created" value={ formatTimestamp( config.created_at, useLocalZone ) } />
      <InfoCard label="Version Updated" value={ formatTimestamp( config.updated_at, useLocalZone ) } />
      <InfoCard label="Version Created By" value={ config.created_by ?? '—' } />
      <InfoCard label="Deprecated" value={ config.is_deprecated ? 'true' : 'false' } />
    </InfoCardRow>
  );
}
